export default {
      id: "LWS-10px-usage",
      viewBox: "0 0 60 10",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#LWS-10px",
      toString: function () {
        return this.url;
      }
    }